import React from 'react'
import { Profile as ProfileController } from '../../components/Profile'
import { useParams } from 'react-router-dom'

export const Profile = (props) => {
  const { address } = useParams();

  const profileProps = {
    ...props,
    address: address,
    isProfile: true
  }

  return (
    <ProfileController {...profileProps} />
  )
}
